import React from "react";
import { FormGroup, FormControl, ControlLabel, HelpBlock } from "rsuite";
import styled from "styled-components";

import { focusPickerSearch } from "utils/inputs";

const widthValues = {
    "md": "200px"
};


class CustomField extends React.PureComponent {
    render() {
        const {
            name, message, label, labelWidth, accepter, error, width, useBr, withCheckbox,
            style: style_, mr, styleFormGroupExternal, styleLabelExternal, icon, ...props
        } = this.props;

        const style = style_ ? { ...style_ } : {};

        if (width) {
            style.width = widthValues[width] || width;
        }
        const styleFormGroup = { ...styleFormGroupExternal };
        (mr) && (styleFormGroup.marginRight = mr);

        const propsLabel = { style: { ...styleLabelExternal } };
        if (labelWidth) {
            propsLabel.style.width = labelWidth;
        }

        return (
            <>
                <StyledFormGroup className={error ? "has-error" : ""} style={styleFormGroup} hasIcon={!!icon}>
                    {label &&
                        <ControlLabel {...propsLabel} >{label} </ControlLabel>
                    }
                    <FormControl
                        name={name}
                        accepter={accepter}
                        errorMessage={error}
                        errorPlacement="topRight"
                        {...props}
                        onOpen={() => {
                            if (props.onOpen) props.onOpen();
                            if (props.searchable === false) return;

                            focusPickerSearch();
                        }}
                        style={style}
                    />
                    {icon || <></>}
                    {message && <HelpBlock>{message}</HelpBlock>}
                </StyledFormGroup>
                {useBr && <br />}
            </>
        );
    }
}


export default CustomField;

const StyledFormGroup = styled(FormGroup)`
    && {
        .rs-icon {
            position: absolute;
            right: 10px;
            color: var(--color-success);
        }
    }
`;